module.exports = __webpack_public_path__ + "static/gippsland-social-2-ec735d24fc5d686f93918ef3ff45c6fe.png";